import dayjs from 'dayjs';
import React from 'react';
import IInvestor from '~Api/Investor/IInvestor';
import NextContactModal from './Investor/NextContactModal';

interface IState {
    isModalOpen: boolean;
}

interface IProps {
    investor: IInvestor;
}

type Props = IProps;

class NextContact extends React.Component<Props, IState> {
    public state: IState = {
        isModalOpen: false,
    };

    constructor(props: Props) {
        super(props);

        this.onClickNextContact = this.onClickNextContact.bind(this);
        this.onNextContactCancel = this.onNextContactCancel.bind(this);
    }

    public render(): JSX.Element {
        const { investor } = this.props;
        const { isModalOpen } = this.state;

        return (
            <React.Fragment>
                <a onClick={this.onClickNextContact}>{investor.contactDateNext ? dayjs(investor.contactDateNext).format('Do MMMM YYYY') : '-'}</a>
                <NextContactModal
                    investor={investor}
                    isOpen={isModalOpen}
                    onCancel={this.onNextContactCancel}
                />
            </React.Fragment>
        );
    }

    private onClickNextContact() {
        this.setState({
            isModalOpen: true,
        });
    }

    private onNextContactCancel() {
        this.setState({
            isModalOpen: false,
        });
    }
}

export default NextContact;
